export default "__VITE_ASSET__CVkh0wAN__"